<template>
  <v-card color="white" class="rounded">
    <!-- <v-card-title class="mb-0">
      <h4 class="headline">Details</h4>
    </v-card-title> -->
    <v-card-text>
      <v-form
        v-model="FormValid"
        v-on:submit.prevent="saveOrganization"
        ref="form"
      >
        <v-text-field
          :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
          v-model="localOrgDetails.name"
          label="Organization Name"
          :rules="organizationNameRules"
        ></v-text-field>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.address"
              label="Address"
              placeholder="Address"
              :rules="addressRules"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.city"
              label="City"
              placeholder="City"
              :rules="addressRules"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              v-if="
                localOrgDetails.country != 'IN' &&
                localOrgDetails.country != 'US'
              "
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.state"
              label="State"
              placeholder="State"
              :rules="addressRules"
            ></v-text-field>
            <v-select
              v-if="localOrgDetails.country === 'IN'"
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.state"
              :items="stateListIN"
              label="State"
              placeholder="State"
              :rules="requiredRules"
            ></v-select>
            <v-select
              v-if="localOrgDetails.country === 'US'"
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.state"
              :items="stateListUS"
              label="State"
              placeholder="State"
              :rules="requiredRules"
            ></v-select>
          </v-flex>
          <v-flex>
            <v-text-field
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.zip"
              label="Zip"
              placeholder="Zip"
              :rules="addressRules"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-select
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.country"
              :items="countryList"
              item-text="text"
              item-value="value"
              label="Country"
              placeholder="Country"
              :rules="requiredRules"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.contactPerson"
              label="Contact Person Name"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="localOrgDetails.phoneNumber"
              label="Contact Number"
              :rules="phoneRules"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-select
          v-if="$store.getters.isSuperAdmin"
          :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
          v-model="localOrgDetails.baseCurrency"
          :items="baseCurrencyList"
          item-text="text"
          item-value="value"
          label="Base Currency"
        ></v-select>

        <v-combobox
          :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
          v-model="localOrgDetails.notificationEmails"
          :items="localOrgDetails.notificationEmails"
          :rules="emailAddressArrayRules"
          hint="Will use these email addresses to send general notifications"
          persistent-hint
          label="Notification Emails (Enter email addresses. Separate by pressing Enter key.)"
          multiple
          chips
        ></v-combobox>
        <v-combobox
          class="mt-3"
          :disabled="!$store.getters.userIsAdministrative"
          v-model="localOrgDetails.accountingEmails"
          :items="localOrgDetails.accountingEmails"
          :rules="emailAddressArrayRules"
          hint="Will use these email addresses to send accounts related notifications"
          persistent-hint
          label="Accounting Emails (Enter email addresses. Separate by pressing Enter key.)"
          multiple
          chips
        ></v-combobox>
        <v-text-field
          class="mt-3"
          v-if="$store.getters.isSuperAdmin"
          :disabled="!$store.getters.userIsAdministrativeOrOrgOwner"
          type="number"
          v-model="localOrgDetails.conversionRate"
          label="Fund Conversion Rate (per Ovation Unit)"
          placeholder="Enter Ovation Rate"
          :rules="amountRules"
          hint="This conversion rate will be used while adding/buying ovations"
          persistent-hint
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <div class="ml-2 mb-2">
        <v-btn
          class="btn-rounded-medium white--text"
          v-if="$store.getters.userIsAdministrativeOrOrgOwner"
          color="#d13b55"
          @click.prevent="saveOrganization"
          :disabled="!FormValid"
        >
          Save
        </v-btn>
      </div>
      <!-- <v-spacer></v-spacer>
      <div
        class="text-sm-right"
        v-if="
          $store.getters.userIsAdministrativeOrOrgOwner &&
          !$store.getters.isCurrentOrgChild
        "
      >
        <v-chip
          class="font-weight-black"
          outline
          color="#e21f4c"
          title="Org Total Distribute Ovations"
        >
          <v-avatar>
            <v-icon>mdi-coins</v-icon>
          </v-avatar>
          {{ $store.state.userSelf.orgDistributeOvations }}
        </v-chip>
        <v-chip
          class="font-weight-black"
          outline
          color="#3cc0c9"
          title="Org Total Send Ovations"
        >
          <v-avatar>
            <v-icon>mdi-coins</v-icon>
          </v-avatar>
          {{ $store.state.userSelf.orgSendOvations }}
        </v-chip>
        <v-chip
          class="font-weight-black"
          outline
          color="#e0922f"
          title="Org Total Spend Ovations"
        >
          <v-avatar>
            <v-icon>mdi-coins</v-icon>
          </v-avatar>
          {{ $store.state.userSelf.orgSpendOvations }}
        </v-chip>
      </div> -->
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import debounce from "debounce";
import validationRules from "@/js/validationRules.js";

export default {
  name: "OrganizationDetailsComponent",
  data() {
    return {
      localOrgDetails: {},
      FormValid: true,
      nameRules: validationRules.nameRules,
      organizationNameRules: validationRules.organizationNameRules,
      addressRules: validationRules.addressRules,
      phoneRules: validationRules.phoneRules,
      emailAddressArrayRules: validationRules.emailAddressArrayRules,
      amountRules: validationRules.integerRules,
      requiredRules: validationRules.requiredRules,
      baseCurrencyList: [
        { text: "Australian Dollar", value: "AUD" },
        { text: "British Pound", value: "GBP" },
        { text: "Canadian Dollar", value: "CAD" },
        { text: "Euro", value: "EUR" },
        { text: "Indian Rupee", value: "INR" },
        { text: "Singapore Dollar", value: "SGD" },
        { text: "US Dollar", value: "USD" },
      ],
      countryList: [
        { text: "Australia", value: "AU" },
        { text: "Canada", value: "CA" },
        { text: "France", value: "FR" },
        { text: "Germany", value: "DE" },
        { text: "India", value: "IN" },
        { text: "Singapore", value: "SG" },
        { text: "United Arab Emirates", value: "AE" },
        { text: "United Kingdom", value: "GB" },
        { text: "United States", value: "US" },
      ],
      stateListIN: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ],
      stateListUS: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "Armed Forces Africa",
        "Armed Forces Americas",
        "Armed Forces Canada",
        "Armed Forces Europe",
        "Armed Forces Middle East",
        "Armed Forces Pacific",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States Of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Islands",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
    };
  },
  watch: {
    // If another component (ie Create Organization component displayed at the same time as this component) updates the userSelf, the updates will take place in this component
    "$store.state.userSelf.currentOrg.org": function () {
      this.$refs.form.reset();
      // TODO: below is a temporary solution to a weird race condition with resetting the form and repopulating it.
      setTimeout(() => {
        this.setLocalOrgDetailsFromGlobal();
        this.$refs.form.resetValidation();
      }, 500);
    },
  },
  computed: {},
  methods: {
    setLocalOrgDetailsFromGlobal: function () {
      this.localOrgDetails = JSON.parse(
        JSON.stringify((this.$store.state.userSelf.currentOrg || {}).org)
      );
      this.setNotificationEmailsIfNull();
      this.setAccountingEmailsIfNull();
    },
    setNotificationEmailsIfNull: function () {
      if (
        this.localOrgDetails &&
        (!this.localOrgDetails.notificationEmails ||
          !Array.isArray(this.localOrgDetails.notificationEmails))
      ) {
        this.localOrgDetails.notificationEmails = []; // This will help to prevent error
      }
    },
    setAccountingEmailsIfNull: function () {
      if (
        this.localOrgDetails &&
        (!this.localOrgDetails.accountingEmails ||
          !Array.isArray(this.localOrgDetails.accountingEmails))
      ) {
        this.localOrgDetails.accountingEmails = []; // This will help to prevent error
      }
    },
    saveOrganization: function () {
      // Disable form submission while async call takes place
      this.FormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving organization details...",
        messageType: "warning",
      });

      const params = this.localOrgDetails;
      params.conversionRate = parseFloat(params.conversionRate);

      axios
        .put("/api/org", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Allow form submission
          this.FormValid = true;

          // Save the retured user object which has the updated currentOrg info
          this.$store.commit("setUserSelf", response.data.user);

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Organization Profile Saved.",
          });
        })
        .catch((e) => {
          // Allow form submission
          this.FormValid = true;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization Profile was NOT updated.<br><strong>" +
              e.response.data.message +
              "</strong><br>Error #KDN848",
            messageType: "error",
          });
        });
    },
  },
  beforeMount() {
    this.setLocalOrgDetailsFromGlobal();
  },
};
</script>
